import type { components } from '@/lib/openapi.generated'

type UserDirectorySource = components['schemas']['UserDirectorySource']

export function decodeUserDirectorySource(raw: unknown): UserDirectorySource {
  switch (raw) {
    case 'manual':
    case 'csv':
    case 'scim':
    case 'federated_jit':
      return raw
    default:
      throw new Error('Malformed user directory source')
  }
}

export const userDirectorySourceLabels = {
  manual: 'Manual',
  csv: 'CSV import',
  scim: 'SCIM',
  federated_jit: 'Single sign-on',
} satisfies Record<UserDirectorySource, string>
